import MembAccnDtlInfoInqApi from "Apis/MembAccnDtlInfoInqApi";
import { useCallback, useEffect, useState, useRef} from "react";
import { Link } from "react-router-dom";
import NickNameChngApi from "Apis/NickNameChngApi";
import useRecaptcha from 'Utils/useRecaptcha';
import { useDispatch, useSelector } from "react-redux";
import { SetNickname } from "Stores/LoginInfoReducer";
import RsvdInfoApi from "Apis/RsvdInfoApi";
import RcmnInfoApi from "Apis/RcmnInfoApi";
import "Assets/css/MembGameRelLst.css";

const MembAccnDtlInfoUi = ({langData}:any) => {
    const dispatch = useDispatch();
    const [membAccnDtlInfo,setMembAccnDtlInfo] = useState<any>();
    const [nickNameInputVal, setNickNameInputVal] = useState<string>("");
    const [nickNameErrorActive, setNickNameErrorActive] = useState<boolean>(false);
    const [nickNameSuccessActive, setNickNameSuccessActive] = useState<boolean>(false);
    const [isEditingNickname, setIsEditingNickname] = useState<boolean>(false);
    const [toastMsg, setToastMsg] = useState<string | null>(null);
    const [rcmnModalOpen, setRcmnModalOpen] = useState(false);
    const [rcmnFetchError, setRcmnFetchError] = useState<string | null>(null);
    const [rcmnInfo, setRcmnInfo] = useState<{ rcmnNick: string; rcmnTag: string; rcmndCnt: number; rcmnYn: string } | null>(null);


    const [resultModalOpen, setResultModalOpen] = useState(false);
    const [resultModalMessage, setResultModalMessage] = useState("");
    const [modalAction, setModalAction] = useState<(() => void) | null>(null);
    const toastTimeoutRef = useRef<number | null>(null);
    const loginInfo = useSelector((state: any) => state.LoginInfoState?.LoginInfo?.apiBody);
    const trimToMaxBytes = (value: string, maxBytes: number) => {
        let result = "";
        let byteLen = 0;
        for (const ch of value) {
            const charBytes = ch.charCodeAt(0) > 0x7f ? 2 : 1;
            if (byteLen + charBytes > maxBytes) break;
            result += ch;
            byteLen += charBytes;
        }
        return result;
    };
    
    useEffect(()=>{
        MembAccnDtlInfoInqApi()
        .then((resp) => {
            setMembAccnDtlInfo(resp.apiBody);
            setNickNameInputVal(resp.apiBody?.nickname || ""); // 초기 닉네임 값 설정
        });
    },[]);
    
    const nickNameInputHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        const noWhitespaceValue = event.currentTarget.value.replace(/\s/g, "");
        const nextValue = trimToMaxBytes(noWhitespaceValue, 16);
        setNickNameInputVal(nextValue);
        setNickNameErrorActive(false); // 입력 시 에러 상태 초기화
        setNickNameSuccessActive(false); // 입력 시 성공 상태도 초기화
    };
    
    const { getToken } = useRecaptcha();
    const NickNameChngFunc = async () => {
        if (nickNameInputVal.length < 1) {
            setNickNameErrorActive(true);
            setNickNameSuccessActive(false);
            return;
        }

        const token = await getToken('nick_change');
        NickNameChngApi(nickNameInputVal, token) // 입력된 닉네임 값 사용
        .then((resp) => {  
            if(resp.apiHdr.code == "COMM3013") {
                setNickNameErrorActive(true); // 에러 상태 활성화
                setNickNameSuccessActive(false); // 성공 상태 비활성화
            } else if(resp.apiHdr.code == "MEMB0000") {
                setNickNameErrorActive(false); // 에러 상태 비활성화
                setNickNameSuccessActive(true); // 성공 상태 활성화
                setIsEditingNickname(false); // 편집 모드 종료
                dispatch(SetNickname(nickNameInputVal));
                // 닉네임 변경 성공 시 커스텀 이벤트 발생
                const event = new CustomEvent('nicknameChanged', {
                    detail: { newNickname: nickNameInputVal }
                });
                window.dispatchEvent(event);
            } else {
                setNickNameErrorActive(false);
                setNickNameSuccessActive(false);
            }
            // token requested per-action
        });
    }
    
    const handleNicknameButtonClick = () => {
        if(isEditingNickname) {
            // 편집 중 -> 저장
            NickNameChngFunc();
        } else {
            // 편집 아님 -> 편집 시작
            setIsEditingNickname(true);
            setNickNameErrorActive(false);
            setNickNameSuccessActive(false);
        }
    }
    
    const copyTextToClipboard = (textToCopy: string) => {
        if (!textToCopy) {
            setToastMsg(langData&&langData.GLB_COPY_FAIL_ALRT_00);
            return;
        }

        const fallbackCopy = (text: string) => {
            const textarea = document.createElement('textarea');
            textarea.value = text;
            textarea.style.position = 'fixed';
            textarea.style.left = '-9999px';
            document.body.appendChild(textarea);
            textarea.select();
            try {
                document.execCommand('copy');
                setToastMsg(langData&&langData.GLB_COPY_ALRT_00);// "클립보드에 복사되었습니다!"
            } catch (e) {
                console.error('Fallback 복사 실패:', e);
                setToastMsg(langData&&langData.GLB_COPY_FAIL_ALRT_00);// "복사에 실패했습니다."
            }
            document.body.removeChild(textarea);
        };

        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(textToCopy).then(() => {
                setToastMsg(langData&&langData.GLB_COPY_ALRT_00);
            }).catch((err) => {
                console.error('Clipboard API 복사 실패:', err);
                fallbackCopy(textToCopy);
            });
        } else {
            fallbackCopy(textToCopy);
        }
    }

    const copyNicknameToClipboard = () => {
        copyTextToClipboard(`${nickNameInputVal}#${membAccnDtlInfo?.membRcmnCd}`);
    }

    const copyMembRcmnCdToClipboard = () => {
        copyTextToClipboard(membAccnDtlInfo?.membRcmnCd || "");
    }

    const rcmnInfoFunc =() => {
        RcmnInfoApi()
        .then((resp) => {
            switch(resp.apiHdr.code){
                case "MEMB0000":
                    {
                        const rcmndCnt = Number(resp.apiBody?.rcmndCnt ?? 0);
                        const rcmnNick = String(resp.apiBody?.rcmnNick ?? "").trim();
                        const rcmnTag = String(resp.apiBody?.rcmnTag ?? "").trim();
                        const rcmnYn = String(resp.apiBody?.rcmnYn ?? "N").trim();
                        setRcmnInfo({ rcmndCnt, rcmnNick, rcmnTag, rcmnYn });
                        setRcmnFetchError(null);
                        setRcmnModalOpen(true);
                    }
                    break;
                default:
                    setRcmnInfo(null);
                    setRcmnFetchError(resp.apiHdr?.msg || "추천 현황 조회에 실패했습니다.");
                    setRcmnModalOpen(true);
                    return;
            }
        })
        .catch(() => {
            setRcmnInfo(null);
            setRcmnFetchError("추천 현황 조회 중 오류가 발생했습니다.");
            setRcmnModalOpen(true);
        });
    }
    
    useEffect(() => {
        if (!toastMsg) return;
        if (toastTimeoutRef.current) {
            window.clearTimeout(toastTimeoutRef.current);
        }
        toastTimeoutRef.current = window.setTimeout(() => {
            setToastMsg(null);
            toastTimeoutRef.current = null;
        }, 2500);
        return () => {
            if (toastTimeoutRef.current) {
                window.clearTimeout(toastTimeoutRef.current);
                toastTimeoutRef.current = null;
            }
        };
    }, [toastMsg]); 

    useEffect(() => {
        if (!rcmnModalOpen) {
            return;
        }

        const originalOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";

        return () => {
            document.body.style.overflow = originalOverflow;
        };
    }, [rcmnModalOpen]);
        
    return(
        <>
        <div className="myPageCard">
            <h2>My Account</h2>
            <div className="myPageCardCtxt">
                <ul>
                    <li className="myPageCardCtxtLi">
                        <div className="ctxtLiTitl">
                            <span className="accountInfoLbl">{langData&&langData.MYPAGE_MAIN_MEMB_ID_LBL_00}</span>
                            {/* 아이디: */}
                            <p>{membAccnDtlInfo&&membAccnDtlInfo.loginId}</p>
                        </div>
                    </li>
                    {membAccnDtlInfo&&membAccnDtlInfo.maskMembNm != ""&&membAccnDtlInfo&&membAccnDtlInfo.maskMembNm != null  ? 
                        <li className="myPageCardCtxtLi">
                            <div className="ctxtLiTitl">
                                <span className="accountInfoLbl">{langData&&langData.MYPAGE_MAIN_MEMB_NM_LBL_00}</span>
                                {/* 이름: */}
                                <p>{membAccnDtlInfo&&membAccnDtlInfo.maskMembNm}</p>
                            </div>
                        </li>
                        :<>
                        </>
                    }
                    <li className="myPageCardCtxtLi">
                            <div className="ctxtLiTitl">
                                <span className="accountInfoLbl">{langData&&langData.MYPAGE_MAIN_MEMB_NICKNAME_LBL_00}</span>
                                {/* 닉네임: */}
                                <div className="nickNameInputWrap">
                                    <div>
                                        {isEditingNickname ? (
                                            <input 
                                                type="text" 
                                                className="nickNameInput" 
                                                value={nickNameInputVal}
                                                onChange={nickNameInputHandler}
                                                maxLength={16}
                                                autoComplete="off"
                                                autoFocus
                                            />
                                        ) : (
                                            <div className="nickNameDisplay">
                                                <button onClick={copyNicknameToClipboard} className="nickNameCopy">
                                                    <p>{nickNameInputVal}</p>
                                                    <span >#{membAccnDtlInfo&&membAccnDtlInfo.membRcmnCd}</span>
                                                    <img src={process.env.PUBLIC_URL+`/images/Mypage/copyIcon.png`} alt="copyIcon" />
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                    <span className={
                                        nickNameErrorActive ? "nickNameLbl active error" : 
                                        nickNameSuccessActive ? "nickNameLbl active success" : "nickNameLbl"
                                    }>
                                        {nickNameErrorActive ? 
                                            langData&&langData.MYPAGE_NICK_CHNG_FAIL_LBL_00 : 
                                            nickNameSuccessActive ? 
                                                langData&&langData.MYPAGE_NICK_CHNG_SUCCESS_LBL_00 : ""
                                        }
                                    </span>
                                </div>
                            </div>
                            <button onClick={handleNicknameButtonClick}>
                                {isEditingNickname ? langData&&langData.DPST_ODR_STTU_CHARGE : langData&&langData.MYPAGE_MAIN_NICKNAME_CHNG_BTN_00}
                                {/* 닉네임 변경 */}
                            </button>
                        </li>
                        <li className="myPageCardCtxtLi">
                        <div className="ctxtLiTitl">
                            <span className="accountInfoLbl">{langData&&langData.MYPAGE_MAIN_MEMB_PWCHNGDTIME_LBL_00}</span>
                            {/* 이메일: */}
                            <p>{membAccnDtlInfo&&membAccnDtlInfo.passwdUpdtDtime}</p>
                        </div>
                        {   membAccnDtlInfo&&membAccnDtlInfo.idntMthdCd =="NA"?
                            <Link to={"/MyPage/IdntMthdChng"} className="moNone">
                            {langData&&langData.MYPAGE_MENU_PASSWD_CHNG_BTN_00}
                                {/* 이메일 변경 */}
                            </Link> :
                            <Link to={"/MyPage/PasswdChng"} className="moNone">
                            {langData&&langData.MYPAGE_MENU_PASSWD_CHNG_BTN_00}
                                {/* 비밀번호 변경 */}
                            </Link>
                        }
                    </li>
                    <li className="myPageCardCtxtLi">
                        <div className="ctxtLiTitl">
                            <span className="accountInfoLbl">{langData&&langData.MYPAGE_MAIN_MEMB_MBP_LBL_00}</span>
                            {loginInfo&&loginInfo.idntMthdCd =="NA"?
                                <p>{langData&&langData.MYPAGE_MAIN_NO_MBP_BTN_00}</p>:
                                <>
                                {/* 휴대폰: */}
                                {   membAccnDtlInfo&&membAccnDtlInfo.idntMthdCd =="EML"?
                                    <p>{langData&&langData.MEMB_TYPE_EML_00}</p>
                                    :<p>{membAccnDtlInfo&&membAccnDtlInfo.mbpNo}</p>
                                }
                                </>
                            }
                        </div>
                        {   membAccnDtlInfo&&membAccnDtlInfo.idntMthdCd =="EML"||membAccnDtlInfo&&membAccnDtlInfo.idntMthdCd =="NA"?
                            <Link to={"/MyPage/IdntMthdChng"} className="moNone">
                            {langData&&langData.MYPAGE_MAIN_ATHN_CHNG_BTN_01}
                                {/* 인증수단 변경 */}
                            </Link> :
                            <></>
                        }
                    </li>
                    <li className="myPageCardCtxtLi">
                        <div className="ctxtLiTitl">
                            <span className="accountInfoLbl">{langData&&langData.MYPAGE_EML_CHNG_INPUT_LBL_00}</span>
                            {/* 이메일: */}
                            {loginInfo&&loginInfo.emlYn === "Y" ? (
                                <p>{membAccnDtlInfo&&membAccnDtlInfo.emlAddr}</p>
                            ) : (
                                <p>{langData&&langData.MYPAGE_MAIN_NO_EML_BTN_00}</p>
                            )}
                        </div>
                        {   membAccnDtlInfo&&membAccnDtlInfo.idntMthdCd =="NA" ?
                            <Link to={"/MyPage/eml"} className="moNone">
                            {langData&&langData.MYPAGE_MAIN_EML_CHNG_BTN_01}
                                {/* 이메일 등록 */}
                            </Link> :
                            <Link to={"/MyPage/EmlChng"} className="moNone">
                                {loginInfo&&loginInfo.emlYn === "N"
                                    ? (langData&&langData.MYPAGE_MAIN_EML_CHNG_BTN_01)
                                    : (langData&&langData.MYPAGE_MAIN_EML_CHNG_BTN_00)
                                }
                                {/* 이메일 변경 */}
                            </Link>
                        }
                    </li>
                    <li className="myPageCardCtxtLi">
                        <div className="ctxtLiTitl">
                            {/* <span>{langData&&langData.MYPAGE_MAIN_RCMN_CD_LBL_00}</span> */}
                            <span className="accountInfoLbl">{langData&&langData.MYPAGE_MAIN_RCMN_CD_LBL_00}</span>
                            {/*내 추천인코드: */}
                            <button type="button" onClick={copyMembRcmnCdToClipboard} className="nickNameCopy">
                                <p>{membAccnDtlInfo&&membAccnDtlInfo.membRcmnCd}</p>
                                <img src={process.env.PUBLIC_URL+`/images/Mypage/copyIcon.png`} alt="copyIcon" />
                            </button>
                        </div>
                        <button onClick={rcmnInfoFunc}>
                            {langData&&langData.MYPAGE_MAIN_RCMN_CHK_BTN_00}
                            {/* 추천 현황 */}
                        </button>
                    </li>
                </ul>
            </div>
        </div>
        {toastMsg && (
            <div className="mbti-toast" role="status" aria-live="polite">
                {toastMsg}
            </div>
        )}
        {rcmnModalOpen && (
            <div className="mdalWrap dpstLpop mdalCommWrap">
                <div className="mdalBg" onClick={() => setRcmnModalOpen(false)}></div>
                <div className="mdalCtxtWrap mdalCommContainer">
                    <div className="membGameSvcMnyLpopTitlWrap" style={{ paddingBottom: 0 }}>
                        <h1 style={{ fontSize: 23, fontWeight: 700, marginBottom: 4 }}>{langData?.MYPAGE_MAIN_RCMN_CHK_BTN_00 || "추천 현황"}</h1>
                        <p style={{ color: "#616367", fontSize: 13 }}>{langData?.MYPAGE_MAIN_RCMN_CD_MDAL_DESC_00 || "나를 추천한 인원수와 내가 등록한 추천 코드를 확인하실 수 있습니다."}</p>
                        {rcmnFetchError ? (
                            <div style={{ marginTop: 14, padding: "11px 13px", borderRadius: 8, background: "#fff1f1", border: "1px solid #ffd4d4" }}>
                                <p style={{ color: "#cf2f2f", fontSize: 13, fontWeight: 500 }}>{rcmnFetchError}</p>
                            </div>
                        ) : (
                            <div style={{ marginTop: 14, borderRadius: 10, border: "1px solid #e6eaed", background: "#fbfcfd", overflow: "hidden" }}>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10, padding: "10px 12px", borderBottom: "1px solid #e6eaed" }}>
                                    <p style={{ color: "#4f5965", fontSize: 12, fontWeight: 500, whiteSpace: "nowrap", marginTop:0}}>{langData?.MYPAGE_MAIN_RCMN_CD_MDAL_LBL_01 || "나를 추천한 인원 :"}</p>
                                    <p className="totMnyText" style={{ fontSize: 17, fontWeight: 700, textAlign: "right", marginTop:0 }}>{rcmnInfo?.rcmndCnt ?? 0}</p>
                                </div>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10, padding: "10px 12px" }}>
                                    <p style={{ color: "#4f5965", fontSize: 12, fontWeight: 500, whiteSpace: "nowrap" , marginTop:0}}>{langData?.MYPAGE_MAIN_RCMN_CD_MDAL_LBL_02 || "내가 등록한 추천 코드 :"}</p>
                                    <p
                                        className="totMnyText"
                                        style={{
                                            fontSize: 17,
                                            fontWeight: 700,
                                            textAlign: "right",
                                            color: rcmnInfo?.rcmnYn === "N" ? "#ff3939" : "#398aff"
                                            , marginTop:0
                                        }}
                                    >
                                        {rcmnInfo?.rcmnYn === "N" ? "X" : `${rcmnInfo?.rcmnNick ?? ""}#${rcmnInfo?.rcmnTag ?? ""}`}
                                    </p>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="dpstLstMdalClose" style={{ marginTop: 16 }}>
                        <button className="mdalCloseBtn" onClick={() => setRcmnModalOpen(false)}>
                            <p>{langData?.COMM_MAIN_CHK_MAIN_BTN_00 || "확인"}</p>
                        </button>
                    </div>
                </div>
            </div>
        )}
        {/* reCAPTCHA provided at app root; per-page provider removed */}
        </>
    )
}

export default MembAccnDtlInfoUi;